// import {
// kategoriTindakanOptions,
// jenisAnestesiOptions,
// golonganTindakanOptions,
// } from "@/data/helper.js";

export const costConstant = {
  operator: 500000,
  anestesi: 200000,
  referal: 100000,
  perawat_anestesi: 100000,
  instrumentator: 50000,
  sirkuler: 25000,
  sirkuler_formatted: "Rp 25.000",
  kamar: 50000,
  lain: 0,
};
export let data = {
  title: "Daftarkan Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Daftarkan Operasi", active: true },
  ],
};
export let dataOperasi = {
  title: "Data Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Input Data Operasi", active: true },
  ],
};
export let dataCeklis = {
  title: "Ceklis Keselamatan Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Isi Form Ceklis Keselamatan Operasi", active: true },
  ],
};
export let dataKondisi = {
  title: "Kondisi Pre dan Post Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Isi Form Kondisi Pre dan Post Operasi", active: true },
  ],
};
export let dataSurveilans = {
  title: "Form Surveilans",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Isi Form Surveilans", active: true },
  ],
};
export let dataEdit = {
  title: "Ubah Form Pendaftaran Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Ubah Form Pendaftaran Operasi", active: true },
  ],
};
export let today = new Date();
import { getTime } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Operasi",
        type: "date",
        placeholder: "Pilih tanggal operasi",
        name: "tanggal",
        value: today,
        defaultValue: today,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Jam Operasi",
        type: "time",
        placeholder: "",
        name: "sign_in",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
];
export let leftForm = [
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Kategori Tindakan",
  //       type: "select",
  //       placeholder: "Pilih Kategori Tindakan",
  //       name: "kategori_tindakan",
  //       value: "",
  //       mandatory: true,
  //       multiple: false,
  //       options: kategoriTindakanOptions,
  //       additional: ""
  //     }
  //   ]
  // },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Golongan Tindakan",
  //       type: "select",
  //       placeholder: "Pilih Golongan Tindakan",
  //       name: "golongan_tindakan",
  //       value: "",
  //       mandatory: true,
  //       multiple: false,
  //       options:golonganTindakanOptions,
  //       additional: ""
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Nama Operasi",
        type: "text",
        placeholder: "",
        name: "nama_operasi",
        value: "",
        mandatory: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Operator",
        type: "select",
        placeholder: "Pilih Dokter Operator",
        name: "id_dokter_operator",
        value: 0,
        mandatory: true,
        additional: "",
        options: [],
      },
    ],
  },
];
export let rightForm = [
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Jenis Anestesi",
  //       type: "select",
  //       placeholder: "",
  //       name: "jenis_anestesi",
  //       value: "",
  //       options: jenisAnestesiOptions,
  //       mandatory: true
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "button",
        placeholder: "",
        name: "generate_form",
        content: "Generate Form Persetujuan",
        mandatory: false,
        function: () => {},
        optional: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Form Persetujuan",
        type: "file",
        placeholder: "",
        name: "file_persetujuan",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
];
export let costForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Biaya Paket Operasi",
        type: "money",
        placeholder: "",
        name: "jenis_paket_operasi",
        value: 0,
        mandatory: true,
        disabled: true,
        additional: "diambil dari total biaya tindakan operasi",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Dokter Operator",
        type: "money",
        placeholder: "",
        name: "jasa_dokter_operator",
        value: 0,
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Dokter Anestesi",
        type: "money",
        placeholder: "",
        name: "jasa_dokter_anestesi",
        value: 0,
        mandatory: true,
      },
    ],
  },
  //   {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Jasa Dokter Referal",
  //       type: "money",
  //       placeholder: "",
  //       name: "jasa_dokter_referal",
  //       value: 0,
  //       mandatory: true
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Perawat Anestesi",
        type: "money",
        placeholder: "",
        name: "jasa_perawat_anestesi",
        value: 0,
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Instrumentator",
        type: "money",
        placeholder: "",
        name: "jasa_instrumentator",
        value: 0,
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Perawat Sirkuler",
        type: "money",
        placeholder: "",
        name: "jasa_perawat_sirkuler",
        value: 0,
        mandatory: true,
        disabled: true,
        additional: `3 x ${costConstant.sirkuler_formatted}`,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Sewa Kamar Operasi",
        type: "money",
        placeholder: "",
        name: "sewa_kamar_operasi",
        value: 0,
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pemberian obat dan alat kesehatan",
        type: "money",
        placeholder: "",
        name: "pemberian_obat_dan_alat_kesehatan",
        value: 0,
        mandatory: true,
        disabled: true,
        additional: "diambil dari total biaya obat dan alat kesehatan",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Biaya lain-lain",
        type: "money",
        placeholder: "",
        name: "biaya_lain_lain",
        value: 0,
        mandatory: false,
        optional: true,
      },
    ],
  },
];
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];
